import { createWebHistory, createRouter } from "vue-router";
import appConfig from "../../app.config";
import store from "@/state/store";
// import axios from 'axios';
// import defaultRoutes from './default-routes';

import main from "./main-routes";
import admin from "./admin-routes";
import employer from "./employer-routes";

const routes = [...main, ...admin, ...employer];

// import routes from "./main-routes";

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters["auth/isAuthenticated"]
  const requiresAuth = to.meta.requiresAuth === true

  if (requiresAuth && !isAuthenticated) {
    return next("/login")
  }

  if (
    isAuthenticated &&
    (to.path === "/login" || to.path === "/register")
  ) {
    return next("/dashboard")
  }

  next()
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
           
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }

  document.title = routeTo.meta.title + " | " + appConfig.title;
  next();
});


export default router;
